
import { Button } from "@/components/ui/button";
import { CalendarIcon, AlertTriangle, UserCog } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface BookingConfirmationProps {
  isAuthenticated: boolean;
  isFormValid: boolean;
  isLoading: boolean;
  onBookingSubmit: () => void;
  isProfileComplete?: boolean;
  redirectToProfile?: () => void;
}

export const BookingConfirmation = ({
  isAuthenticated,
  isFormValid,
  isLoading,
  onBookingSubmit,
  isProfileComplete = true,
  redirectToProfile
}: BookingConfirmationProps) => {
  if (!isAuthenticated) {
    return (
      <Button 
        disabled={true}
        className="w-full"
      >
        <CalendarIcon className="mr-2 h-4 w-4" />
        Sign in to Book
      </Button>
    );
  }
  
  if (!isProfileComplete && redirectToProfile) {
    return (
      <TooltipProvider>
        <Tooltip content="You need to provide your contact information before booking">
          <Button 
            onClick={redirectToProfile}
            className="w-full bg-amber-500 hover:bg-amber-600"
          >
            <UserCog className="mr-2 h-4 w-4" />
            Complete Profile to Book
          </Button>
        </Tooltip>
      </TooltipProvider>
    );
  }
  
  return (
    <TooltipProvider>
      <Tooltip content={(!isFormValid || !isProfileComplete) ? (
        !isProfileComplete 
          ? "Complete your profile to enable booking" 
          : !isFormValid 
            ? "Please fill all required fields" 
            : "Ready to book!"
      ) : undefined}>
        <div className="w-full">
          <Button 
            onClick={onBookingSubmit}
            disabled={!isFormValid || isLoading || !isProfileComplete}
            className="w-full"
          >
            <CalendarIcon className="mr-2 h-4 w-4" />
            {isLoading ? "Booking..." : "Book Appointment"}
          </Button>
        </div>
      </Tooltip>
    </TooltipProvider>
  );
};
